import React, { useState } from 'react';
import {
  FaChartLine, FaShieldAlt, FaBullseye, FaCheckCircle,
  FaSearchDollar, FaSyncAlt, FaUserCheck, FaCity, FaGlobeAsia,
  FaBalanceScale, FaAward, FaRegClock, FaUserTie, FaChevronDown,
  FaLightbulb, FaBriefcase, FaBuilding, FaHandHoldingUsd, FaChess
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const PortfolioManagementServices = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "What is Portfolio Management Services (PMS)?",
      a: "Portfolio Management Services (PMS) is a professional investment service where experienced portfolio managers create and manage customized investment portfolios on behalf of clients based on their financial objectives and risk profile."
    },
    {
      q: "Is PMS better than Mutual Funds?",
      a: "PMS offers a personalized portfolio and direct ownership of securities, whereas mutual funds pool money from many investors into a common portfolio. The choice depends on your financial goals, investment amount, and preferences."
    },
    {
      q: "How often is my portfolio reviewed?",
      a: "Your portfolio is reviewed regularly, and adjustments may be made when market conditions or your financial objectives change."
    },
    {
      q: "Can NRIs invest through PMS?",
      a: "Yes, subject to applicable regulations and eligibility requirements."
    }
  ];

  return (
    <main className="pms-page">


      <Helmet>
        {/* Basic SEO */}
        <title>Portfolio Management Services (PMS) in Hyderabad | Portfolio Management Services | PMS Investment | Lotoswealth</title>

        <meta
          name="description"
          content="Lotoswealth offers professional Portfolio Management Services (PMS) in Hyderabad with customized investment strategies, active portfolio management, equity investments, risk management, wealth creation, and long-term financial growth for high-net-worth individuals and investors."
        />

        <meta
          name="keywords"
          content="Portfolio Management Services Hyderabad, Portfolio Management Services , PMS Hyderabad, Portfolio Management Hyderabad, PMS Investment Hyderabad, Portfolio Manager Hyderabad, Investment Portfolio Management Hyderabad, Equity Portfolio Management Hyderabad, Customized Portfolio Management Hyderabad, Wealth Management Hyderabad, Financial Planning Hyderabad, Investment Advisor Hyderabad, Financial Advisor Hyderabad, Asset Management Hyderabad, Equity Investments Hyderabad, Stock Market Investment Hyderabad, Long Term Wealth Creation Hyderabad, HNI Portfolio Management Hyderabad, Professional Portfolio Management Hyderabad, Lotoswealth"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Lotoswealth" />
        <meta name="language" content="English" />

        <link rel="canonical" href="https://www.lotoswealth.com/portfolio-management-services" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Lotoswealth" />
        <meta property="og:url" content="https://www.lotoswealth.com/portfolio-management-services" />
        <meta
          property="og:title"
          content="Portfolio Management Services (PMS) in Hyderabad | Lotoswealth"
        />
        <meta
          property="og:description"
          content="Expert Portfolio Management Services (PMS) in Hyderabad with personalized investment strategies, active portfolio management, risk management, equity investments, and long-term wealth creation."
        />
        <meta
          property="og:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Portfolio Management Services (PMS) in Hyderabad | Lotoswealth"
        />
        <meta
          name="twitter:description"
          content="Grow your wealth with Lotoswealth's Portfolio Management Services (PMS) in Hyderabad. Personalized investment portfolios, expert fund management, and long-term financial growth."
        />
        <meta
          name="twitter:image"
          content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
        />
      </Helmet>

      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>

        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img
            src="/images/portfolio-management-service.jpg"
            alt="Portfolio Management Services"
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Portfolio Management Services
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Expert Portfolio Management for Long-Term Wealth Creation
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth, your trusted partner for Portfolio Management Services (PMS) in Hyderabad and across India. We specialize in providing personalized investment management solutions designed to help investors grow, protect, and preserve their wealth through disciplined investment strategies.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Investing in today's dynamic financial markets requires more than simply buying stocks or mutual funds. It demands a structured investment approach, continuous market monitoring, professional research, risk management, and strategic portfolio rebalancing. At Lotoswealth, we bring all these elements together to deliver customized solutions that align with your objectives.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Whether your goal is capital appreciation, retirement planning, wealth preservation, passive income generation, or creating a financial legacy for future generations, our experienced portfolio managers develop investment strategies that match your unique financial profile.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>

            {/* Duplicated Set for Seamless Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. INTRO & WHY PMS SECTION (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Portfolio Management Services?
              </h2>
              <p className="text-muted line-height-lg">
                Every investor has different financial aspirations, investment horizons, and risk appetites. Generic investment products may not always meet individual financial objectives.
              </p>
              <p className="text-muted line-height-lg">
                Portfolio Management Services (PMS) provide a customized investment solution where experienced professionals manage your investments on your behalf while maintaining complete transparency. Unlike traditional investment products, PMS focuses on personalized portfolio construction rather than a one-size-fits-all approach.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">The Lotoswealth Edge</h4>
                <p className="text-muted small mb-3">
                  At Lotoswealth, our portfolio managers continuously analyze:
                </p>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> Market trends & Economic conditions</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> Company fundamentals</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> Sector performance</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> Emerging investment opportunities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR INVESTMENT PHILOSOPHY (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white">
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">💡 Our Investment Philosophy</h2>
            <p className="text-muted">At Lotoswealth, we believe successful investing is built on discipline rather than speculation. Our philosophy rests on five key principles:</p>
          </div>

          <div className="row g-4 justify-content-center text-center">

            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaChartLine size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Long-Term Wealth Creation</h5>
                <p className="text-muted small">We focus on creating sustainable wealth through quality investments rather than short-term market speculation.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaSearchDollar size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Fundamental Research</h5>
                <p className="text-muted small">Every investment decision is backed by detailed company analysis, financial research, valuation studies, and market intelligence.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBalanceScale size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Diversification</h5>
                <p className="text-muted small">We diversify investments across sectors and industries to reduce concentration risk and improve long-term stability.</p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaShieldAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Risk Management</h5>
                <p className="text-muted small">Protecting capital is equally important as generating returns. We continuously monitor investment risks and rebalance portfolios.</p>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaUserCheck size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Transparency</h5>
                <p className="text-muted small">Clients receive regular reports, portfolio updates, and complete visibility into their individual investments.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. PERSONALIZED PORTFOLIO FACTORS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4 text-center">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">🎯 Personalized Portfolio Management</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2" style={{ maxWidth: '700px', margin: '0 auto' }}>
            No two investors are alike. At Lotoswealth, every investment portfolio is carefully designed based on your unique profile:
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3 animate-slide-up delay-3 mt-4">
            {[
              "Financial Goals", "Investment Experience", "Risk Appetite",
              "Income Level", "Existing Investments", "Age",
              "Tax Situation", "Liquidity Requirements", "Investment Horizon",
              "Future Financial Commitments"
            ].map((factor, idx) => (
              <span key={idx} className="badge bg-white text-dark fs-6 px-3 py-2 rounded-pill shadow-sm">
                ✔️ {factor}
              </span>
            ))}
          </div>
          <p className="mt-4 text-teal-light fst-italic animate-slide-up delay-4">
            Our personalized approach ensures your investment portfolio reflects your financial priorities.
          </p>
        </div>
      </section>

      {/* =========================================
          5. OUR PORTFOLIO PROCESS (Light Gray)
      ========================================= */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">🔄 Our Portfolio Management Process</h2>
            <p className="text-muted">A structured 5-step approach to securing your wealth.</p>
          </div>

          <div className="row g-4">

            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100 position-relative border-top border-3 border-teal">
                <h5 className="fw-bold text-teal mb-3">Step 1 – Financial Consultation</h5>
                <p className="text-muted small">Our investment advisors begin by understanding your current financial position, future objectives, income sources, expenses, liabilities, and investment preferences.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100 position-relative border-top border-3 border-teal">
                <h5 className="fw-bold text-teal mb-3">Step 2 – Risk Assessment</h5>
                <p className="text-muted small mb-2">Every investor has a different comfort level. We assess your profile before recommending strategies:</p>
                <div className="d-flex gap-1 flex-wrap">
                  <span className="badge bg-light text-dark border">Conservative</span>
                  <span className="badge bg-light text-dark border">Moderate</span>
                  <span className="badge bg-light text-dark border">Aggressive</span>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100 position-relative border-top border-3 border-teal">
                <h5 className="fw-bold text-teal mb-3">Step 3 – Portfolio Construction</h5>
                <p className="text-muted small">Creating a diversified portfolio using carefully selected instruments like Large/Mid/Small Cap Stocks, Blue Chips, Mutual Funds, ETFs, Debt, and Alternatives.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100 position-relative border-top border-3 border-teal">
                <h5 className="fw-bold text-teal mb-3">Step 4 – Continuous Monitoring</h5>
                <p className="text-muted small">Markets never remain constant. Our managers monitor Company Performance, Market Trends, Economic Indicators, Interest Rates, Inflation, Corporate Earnings, and Global Events.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100 position-relative border-top border-3 border-teal">
                <h5 className="fw-bold text-teal mb-3">Step 5 – Portfolio Rebalancing</h5>
                <p className="text-muted small">As market conditions change, portfolios require adjustments. We periodically rebalance to maintain the desired asset allocation while minimizing unnecessary risks.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. STRATEGIES & BENEFITS (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white">
        <div className="container py-4">
          <div className="row g-5">

            {/* Strategies */}
            <div className="col-lg-6 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">📈 Portfolio Management Strategies</h3>
              <p className="text-muted small mb-4">We offer multiple investment strategies depending on client objectives.</p>
              <div className="d-flex flex-column gap-3">

                <div className="p-3 bg-light rounded-3 border-start border-4 border-teal shadow-sm">
                  <h5 className="fw-bold text-dark">Growth Portfolio</h5>
                  <p className="text-muted small mb-1">Designed for investors seeking long-term capital appreciation.</p>
                  <span className="text-teal fw-bold" style={{ fontSize: '0.8rem' }}>Ideal for: Young Professionals, Business Owners, Entrepreneurs, Long-Term Investors</span>
                </div>

                <div className="p-3 bg-light rounded-3 border-start border-4 border-teal shadow-sm">
                  <h5 className="fw-bold text-dark">Balanced Portfolio</h5>
                  <p className="text-muted small mb-1">A combination of equity and debt investments designed to balance growth with stability.</p>
                  <span className="text-teal fw-bold" style={{ fontSize: '0.8rem' }}>Suitable for: Investors seeking moderate returns with controlled risk</span>
                </div>

                <div className="p-3 bg-light rounded-3 border-start border-4 border-teal shadow-sm">
                  <h5 className="fw-bold text-dark">Income Portfolio</h5>
                  <p className="text-muted small mb-1">Focused on generating regular income through dividend-paying stocks and fixed-income investments.</p>
                  <span className="text-teal fw-bold" style={{ fontSize: '0.8rem' }}>Ideal for: Retirees and conservative investors</span>
                </div>

                <div className="p-3 bg-light rounded-3 border-start border-4 border-teal shadow-sm">
                  <h5 className="fw-bold text-dark">Wealth Preservation Portfolio</h5>
                  <p className="text-muted small mb-1">Designed to preserve accumulated wealth while maintaining steady long-term growth.</p>
                  <span className="text-teal fw-bold" style={{ fontSize: '0.8rem' }}>Recommended for: High Net Worth Individuals (HNIs)</span>
                </div>

              </div>
            </div>

            {/* Benefits */}
            <div className="col-lg-6 animate-slide-up delay-2">
              <h3 className="fw-bold mb-4 text-dark">🌟 Benefits of Choosing Lotoswealth PMS</h3>
              <ul className="list-unstyled d-flex flex-column gap-3">
                <li className="d-flex align-items-start bg-light p-3 rounded-3">
                  <FaCheckCircle className="text-teal fs-5 me-3 mt-1" />
                  <div>
                    <strong className="d-block text-dark">Personalized Investment Strategies</strong>
                    <span className="text-muted small">Every portfolio is customized according to your financial goals.</span>
                  </div>
                </li>
                <li className="d-flex align-items-start bg-light p-3 rounded-3">
                  <FaCheckCircle className="text-teal fs-5 me-3 mt-1" />
                  <div>
                    <strong className="d-block text-dark">Professional Fund Management</strong>
                    <span className="text-muted small">Experienced professionals manage your investments using research-driven decisions.</span>
                  </div>
                </li>
                <li className="d-flex align-items-start bg-light p-3 rounded-3">
                  <FaCheckCircle className="text-teal fs-5 me-3 mt-1" />
                  <div>
                    <strong className="d-block text-dark">Dedicated Portfolio Manager</strong>
                    <span className="text-muted small">Receive personalized attention and expert guidance throughout your journey.</span>
                  </div>
                </li>
                <li className="d-flex align-items-start bg-light p-3 rounded-3">
                  <FaCheckCircle className="text-teal fs-5 me-3 mt-1" />
                  <div>
                    <strong className="d-block text-dark">Active Risk Management</strong>
                    <span className="text-muted small">We continuously monitor market conditions to protect your investments.</span>
                  </div>
                </li>
                <li className="d-flex align-items-start bg-light p-3 rounded-3">
                  <FaCheckCircle className="text-teal fs-5 me-3 mt-1" />
                  <div>
                    <strong className="d-block text-dark">Transparent Reporting & Planning</strong>
                    <span className="text-muted small">Regular portfolio statements to help you achieve financial independence through disciplined investing.</span>
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          7. TARGET AUDIENCE & WHY US (Soft Blue Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">

            {/* Target Clients */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Should Invest in PMS?</h3>
              <p className="text-muted small mb-4">Portfolio Management Services are suitable for:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "High Net Worth Individuals (HNIs)", "Corporate Executives", "Entrepreneurs",
                  "Business Owners", "Doctors", "IT Professionals", "NRIs", "Family Offices",
                  "Professionals with Surplus Income", "Long-Term Investors"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Choose Lotoswealth?</h3>
                <p className="text-muted small mb-4">Choosing the right portfolio manager is one of the most important financial decisions you can make. Clients trust us because we offer:</p>
                <div className="row g-3">
                  {[
                    "Personalized Financial Advice", "Transparent Investment Process",
                    "Research-Based Investment Decisions", "Diversified Portfolio Construction",
                    "Professional Portfolio Monitoring", "Risk Management Expertise",
                    "Dedicated Relationship Managers", "Ethical Investment Practices",
                    "Long-Term Wealth Creation Strategies", "Regular Client Communication",
                    "Technology-Driven Reporting", "Client-Centric Investment Solutions"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          8. LOCATIONS (HYDERABAD & INDIA) (White)
      ========================================= */}
      <section className="py-5 bg-white">
        <div className="container py-4">
          <div className="row g-4">

            <div className="col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 border">
                <FaCity size={32} className="text-teal mb-3" />
                <h4 className="fw-bold">PMS in Hyderabad</h4>
                <p className="text-muted small mb-3 line-height-lg">
                  Hyderabad has become one of India's leading technology and financial hubs. With increasing income levels and investment awareness, more investors are seeking professional portfolio management services.
                </p>
                <p className="text-muted small mb-0 line-height-lg">
                  Lotoswealth proudly serves investors across Hyderabad. Whether you're a salaried professional in <strong>HITEC City</strong>, a business owner in <strong>Banjara Hills</strong>, an entrepreneur in <strong>Gachibowli</strong>, or a retiree planning your financial future, our advisors help you make informed investment decisions.
                </p>
              </div>
            </div>

            <div className="col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 border">
                <FaGlobeAsia size={32} className="text-teal mb-3" />
                <h4 className="fw-bold">PMS Across India</h4>
                <p className="text-muted small mb-3 line-height-lg">
                  Although headquartered to serve clients in Hyderabad, Lotoswealth provides Portfolio Management Services to investors across India. Our digital investment process allows clients to receive professional advisory services seamlessly.
                </p>
                <div className="d-flex flex-wrap gap-2 mt-3">
                  {["Mumbai", "Delhi", "Bengaluru", "Chennai", "Pune", "Ahmedabad", "Kolkata", "Jaipur", "Kochi", "Visakhapatnam", "Vijayawada", "Hyderabad"].map((city, i) => (
                    <span key={i} className="badge bg-white text-dark border p-2 shadow-sm">{city}</span>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          9. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`}
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          10. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Optimize Your Investment Portfolio?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Get in touch with our expert portfolio managers today and take a disciplined approach towards long-term wealth creation.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Schedule a PMS Consultation
          </button>
        </div>
      </section>

    </main>
  );
};

export default PortfolioManagementServices;